export default () => {
  const speed = 1000,
    offset = 80

  $('a[href^="#"]').on('click', function() {
    const target = $(this.hash)
    let targetY
    if (!target.length) return
    if (window.innerWidth <= 960) {
      targetY = target.offset().top - offset
    } else {
      targetY = target.offset().top
    }
    $('html,body').animate({ scrollTop: targetY }, speed, 'easeOutExpo')
    return false
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/anchor-link.js